module.exports = __webpack_public_path__ + "static/Caitlin-a5db4ea3a48b5973513138364b7dadbc.jpg";